<!-- ReportBuilder.vue -->
<template>
  <div class="component" ref="base">
    <div class="main">
        <TrialPayment :neverShowButton="true" />
        <div class="box" v-if="ready">
        <div class="columns">
          <div class="column is-half">
            <p class="title is-5">
              Portfolio
              <a v-if="!$root.$data.isEmbed" href="/advisordashboard/model_portfolio_upload" class="icon is-small has-text-primary"><i class="fas fa-upload fa-xs"></i></a>
            </p>

            <TypeaheadPortfolioSearch
              placeholder="Search for people, portfolios, or tickers"
              v-bind:selected="activePortfolio"
              v-bind:callback="selectPortfolio"
              :returnEntities='true'
            />
          </div>
          <div class="column is-half">
            <p class="title is-5">Comparison</p>
            <TypeaheadPortfolioSearch
              placeholder="Search for people, portfolios, or tickers"
              v-bind:selected="benchmarkPortfolio"
              v-bind:callback="selectBenchmark"
              :returnEntities='true'
            />

          </div>
        </div>

        <div v-if="activePortfolio">
          <div class="columns">
            <div class="column is-half">
              <div>
                <div class="flexvaluesmenu">
                  <span class="title is-5">Values</span>
                  <a
                  class="is-size-6"
                    href="#_"
                    v-on:click="openValuesPicker"
                  >
                    &#x21bb;
                    &nbsp;
                    Select different Values
                  </a>
                </div>
                <span class="tag is-info is-light " v-if="activeValues.length === 0">All Values</span>
                <!-- <div class="block" v-if="valuesPortfolio.id">
                  <PortfolioIcon v-bind:portfolioType="valuesPortfolio.portfolio_type"/>
                  <p>{{ valuesPortfolio.name }}</p>
                </div> -->
                <div class="tags">
                  <ValueTag
                    v-for="(set, index) in activeValues"
                    v-bind:screen_set="set"
                  />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="container">
                <p class="help">
                  <strong>Disclaimer</strong>
                  <br>
                  Reports generated on this page are For Client Use.
                  <br>
                  You are responsible for your choices when changing from the default benchmark.
                  <br>
                  <b-field v-show="benchmarkPortfolio.id !== null" class="comparison-portfolio-is-benchmark">
                    Comparison portfolio is a benchmark
                    <b-tooltip
                      multilined
                      label="Shareholder engagement is not assigned to benchmark portfolios."
                    >
                      <b-checkbox v-model="benchmarkNoEngagement">
                      </b-checkbox>
                     </b-tooltip>
                  </b-field>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="box">
        <div class="columns">
          <div class="column is-half">
            <b-skeleton width="100%" height="35px" class="level-item"/>
            <b-skeleton width="100%" height="25px" class="level-item"/>
            <b-skeleton width="100%" height="40px" class="level-item"/>
            <b-skeleton width="100%" height="30px" class="level-item"/>
            <i class="icon is-medium">
              <b-skeleton/>
            </i>
            <i class="icon is-medium">
              <b-skeleton/>
            </i>
          </div>
          <div class="column is-half">
            <b-skeleton width="100%" height="35px" class="level-item"/>
            <b-skeleton width="100%" height="25px" class="level-item"/>
            <br><br>
            <b-skeleton width="100%" height="30px" class="level-item"/>
          </div>
        </div>
      </div>
      <div v-if="previewSrc()" style="display: block;">
      

        <div class="box">
          <div class="columns">
            <div class="column">
              <p class="title is-4">
                Preview&nbsp;&nbsp;
                <b-tooltip
                  label="See full size"
                >
                  <a v-bind:href="fullSizeHref" target="_blank" rel="noreferrer noopener">
                    <b-icon
                      pack="fas"
                      icon="external-link-alt"
                    />
                  </a>
                </b-tooltip>
                &nbsp;&nbsp;
                <PdfAction
                  v-bind:portfolio="activePortfolio"
                  v-bind:reportUrl="this.previewSrc()"
                />
                &nbsp;&nbsp;
                <ReportLink
                  v-bind:portfolio="activePortfolio"
                  v-bind:reportUrl="this.previewSrc()"
                  v-if="reportType !== 'institutional'"
                />
                <InstitutionalReportLink
                  v-bind:portfolio="activePortfolio"
                  v-bind:reportUrl="this.previewSrc()"
                  v-if="reportType == 'institutional'"
                />
                &nbsp;&nbsp;
                <CsvAction
                  v-bind:portfolio="activePortfolio"
                  v-bind:reportUrl="this.previewSrc()"
                  v-if="reportType !== 'metaphor'"
                />

                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  class="fa-spin is-primary"
                  v-if="rendering"
                />
                &nbsp;&nbsp;
              </p>
            </div>
            <div class="column">
              <div class="buttons is-right">
                <div
                  v-if="reportType !== 'institutional' && reportType !== 'persona'"
                  @click="goToGuide"
                  class="button is-focused is-small is-rounded ">
                  Presenter's Guide
              </div>
                <b-icon
                  v-if="iframe.loading"
                  pack="fas"
                  class="spinning is-pulled-right"
                  type="is-success"
                  icon="recycle"
                />
              </div>
            </div>
          </div><!-- columns -->
          <iframe
            ref="previewFrame"
            scrolling="no"
            v-bind:srcdoc="iframe.srcdoc"
            v-on:load="onPreviewFrameLoad"   
            v-bind:class="iframeClasses">
          </iframe>
        </div>
      </div>
      <div v-else-if="reportNotApplicable" style="display: block;">
        <div class="box">
            <p class="title is-5 has-text-centered">There are no metrics available to display in this report.</p>
            <p class="subtitle is-6 has-text-centered">Check to see if your portfolio only contains securities with no values-metrics (e.g. muni bonds, commodities, cash).</p>
            <p class="subtitle is-6 has-text-centered">YourStake's values metrics cover equities, corporate bonds, and sovereign bonds.</p>
        </div>
      </div>
    </div>
    <div class="side">
      <div class="box">
        <ReportTypePicker
          ref="typePicker"
          v-bind:callback="reportTypeChanged"
          @input="handleReportTypeChange"
        />
      </div>
      <ScreenSelectList
        v-if="activePortfolio && activePortfolio.details && ['impact', 'institutional', 'persona'].includes(reportType)"
        v-bind:screensByIssue="screensByIssue"
        @onClickSaveMetrics="openNameValueSetModal"
      />
      <MetaphorSelectList
        v-if="['metaphor', 'institutional'].includes(reportType) && activePortfolio.id"
        v-bind:portfolio="activePortfolio"
        v-bind:benchmark="benchmarkPortfolio"
        v-bind:callback="metaphorsChanged"
        v-bind:toggleable="reportType === 'institutional'"
        :activeValues="activeValues"
      />
      <ColorPicker
        v-bind:color="bgcolor"
        v-bind:callback="bgColorChanged"
      />

      <PercentageOrDollars
        v-show="reportType == 'institutional'"
        :dollarsOrPercentage="dollarsOrPercentages"
        :callback="dollarsOrPercentagesChanged"
      />

    </div>
    <ScreenDetailPane />
  </div>
</template>

<script>
  import Advisor from '../shared/Advisor.js';
  import Symbol from '@frontend/dash3/js/shared/Symbol.js';

  import PercentageOrDollars from '@frontend/dash3/js/components/PercentageOrDollars.vue';
  import ColorPicker from '@frontend/dash3/js/components/ColorPicker.vue';
  import MetaphorSelectList from '../components/MetaphorSelectList.vue';
  import PortfolioIcon from '../components/portfolios/PortfolioIcon.vue';
  import ReportTypePicker from '../components/ReportTypePicker.vue';
  import ScreenSelectList from '../components/ScreenSelectList.vue';
  import ScreenDetailPane from '@frontend/builder/js/components/ScreenDetailPane.vue';
  import TypeaheadPortfolioSearch from '../components/portfolios/TypeaheadPortfolioSearch.vue';
  import ValuesPicker from '../components/ValuesPicker.vue';
  import ValueTag from '../components/ValueTag.vue';
  import { apiFetch, postScreenSet } from '../../../api/api';
  import { wrapUrlWithSesameLogin } from '../../../api/sesame';
  import TrialPayment from '@frontend/ui/components/utils/TrialPayment.vue';

  import PdfAction from '@frontend/dash3/js/components/reportbuilder/PdfAction.vue';
  import CsvAction from '@frontend/dash3/js/components/reportbuilder/CsvAction.vue';
  import ReportLink from '@frontend/dash3/js/components/report-links/ReportLink.vue';
  import InstitutionalReportLink from '@frontend/dash3/js/components/report-links/institutional/InstitutionalReportLink.vue';

  export default {
    props: ['advisor'],
    data() {
      return {
        portfolios: [],
        prospects: [],
        metrics: {a: [], byId: {}},
        portfolioName: null,
        benchmarkPortfolioName: null,

        activePortfolio: {id: null, portfolio_type: null},
        benchmarkPortfolio: {id: null, portfolio_type: null},
        valuesPortfolio: {id: null, portfolio_type: null},
        activeValues: [],
        originalValues: [],

        benchmarkNoEngagement: true,

        reportType: 'impact',
        reportStyle: 'minimal',
        reportURLBase: '',

        issues: [
          'Health',
          'Environment',
          'Human Rights',
          'Equal Opportunity',
          'Accountability',
        ],

        bgcolor: '',
        dollarsOrPercentages: 'dollars', // or 'percentages'

        appliedMetaphors: [],
        iframe: {
          loading: true,
          srcdoc: null,
        },

        ready: false,

        rendering: false,
        renderRequest: null,
        renderCheckInterval: null,

        partnerUploadMenuVisible: false,

        institutionalSections: {
          'metaphor': true,
        },

        // ticker related UI stuff
        // under the hood tickers use
        // model portfolios as well
        tickerSearch: false,
        tickerBaselineSearch: false, // comparison ticker
      }
    },
    local: {
      previousIframeSrc: null,
    },
    components: {
      PercentageOrDollars,
      ColorPicker,
      MetaphorSelectList,
      // OrionAction,
      PdfAction,
      CsvAction,
      PortfolioIcon,
      ReportLink,
      InstitutionalReportLink,
      ReportTypePicker,
      ScreenSelectList,
      ScreenDetailPane,
      TypeaheadPortfolioSearch,
      ValuesPicker,
      ValueTag,
      TrialPayment,
    },
    computed: {
      activeScreens() {
        return this.activePortfolio.applicable_screens.filter(itm => itm.active);
      },
      iframeClasses: function() {
        let loading = this.iframe.loading ? 'loading' : '';
        return `preview ${loading}`;
      },
      searchablePortfolios: function() {
        return this.portfolios.filter((itm) => {
          return itm.has_holdings;
        })
      },
      screensByIssue: function() {
        let byIssue = {}
        for (let i in this.issues) {
          let issueName = this.issues[i];
          byIssue[issueName] = this.activePortfolio.applicable_screens.filter((itm, idx, arr) => {
            return itm.subcategory[0].esgissue.name === issueName;
          });
        }
        return byIssue
      },
      reportNotApplicable: function() {
        return this.activePortfolio?.id && !this.activePortfolio?.applicable_screens?.length > 0
      },
      iframeSrc: function() {
        // This little dance is to handle the fact that we only want to flag the iframe as "loading"
        // if the url has actually changed, since this can wind up called multiple times as Vue
        // rejiggers things when data changes. To do this, we just store a non-reactive reference to
        // the old iframe src, and compare before flagging it as loading.
        const url = this.previewSrc();
        if(!url) return;

        let newSrc = this.previewSrc() + '&is_iframe=1';
        if (this.$options.local.previousIframeSrc !== newSrc) {
          this.$options.local.previousIframeSrc = newSrc;
          this.iframe.loading = true;
          this.syncQueryString();
        }
        return newSrc;
      },
      fullSizeHref: function() {
        const url = this.previewSrc() + '&tour=true';
        if (this.$root.$data.isEmbed) {
          return wrapUrlWithSesameLogin(url+'&is_embed=1');
        }
        return url;
      },
          },
    watch: {
      benchmarkPortfolio: function() {
        if (this.benchmarkPortfolio.id === null) {
          this.benchmarkNoEngagement = true;
        }
      },
      iframeSrc: async function(newIframeSrc, oldIframeSrc) {
        if (this.reportType === 'metaphor' && !this.appliedMetaphors.length) {
          return;
        }
        await this.refreshIframeSrcDoc();
        this.sendMetaphorsToReport();
      },
    },
    methods: {
      goToGuide() {
        const urlMappingByStyle = {
          sunburst: 'https://23906943.fs1.hubspotusercontent-na1.net/hubfs/23906943/Presenters%20Guides/CF%20YS%20Report%20Professional%20Report%20overview.pdf',
          minimal: 'https://23906943.fs1.hubspotusercontent-na1.net/hubfs/23906943/Presenters%20Guides/CF%20YS%20Report%20Minimal%20Report%20overview.pdf',
          minimal_absolute: 'https://23906943.fs1.hubspotusercontent-na1.net/hubfs/23906943/Presenters%20Guides/CF%20YS%20Report%20Comparison%20Absolute%20Report%20overview.pdf',
          minimal_relative: 'https://23906943.fs1.hubspotusercontent-na1.net/hubfs/23906943/Presenters%20Guides/CF%20YS%20Report%20Comparison%20Relative%20Report%20overview.pdf',
          human: 'https://23906943.fs1.hubspotusercontent-na1.net/hubfs/23906943/Presenters%20Guides/CF%20YS%20Report%20Inspiring%20Report%20overview.pdf',
        }
        const metaphorUrl = 'https://23906943.fs1.hubspotusercontent-na1.net/hubfs/23906943/Presenters%20Guides/CF%20YS%20Report%20Metaphor%20Report%20overview.pdf';
        window.open(this.reportType === 'metaphor' ? metaphorUrl : urlMappingByStyle[this.reportStyle]);
      },
      async openNameValueSetModal() {
        const valueSetName = 'Untitled Value Set From Report';
        this.$buefy.dialog.prompt({
          message: 'Save this value set as:',
          inputAttrs: {
            placeholder: valueSetName,
            maxlength: 200,
            value: valueSetName,
          },
          trapFocus: true,
          closeOnConfirm: false,
          confirmText: 'Save',
          onConfirm: async (value, { close }) => {
            this.$buefy.toast.open(`Saving as: ${value}...`);
            await this.saveNewValueSet(value);
            close();
          },
        });
      },
      async saveNewValueSet(valueSetName) {
        const savedScreenSet = (await postScreenSet(valueSetName, this.activeScreens, this.$root.$data.csrfToken)).data;
        if (savedScreenSet.error) {
          this.$buefy.dialog.alert(savedScreenSet.error);
          return;
        }
      },
      openValuesPicker: function(currentlyApplied) {
        if (this.originalValues.length === 0) {
          this.originalValues.push(...this.activeValues);
        }

        this.$buefy.modal.open({
          parent: this,
          component: ValuesPicker,
          hasModalCard: true,
          trapFocus: true,
          props: {
            additionalValues: this.originalValues,
            currentlyApplied: this.activeValues,
            callback: this.valuesChangeCallback,
          }
        })
      },
      onPreviewFrameLoad: function() {
        this.adjustIframeSize();
        if (this.$root.$data.isEmbed) {
          this.wrapPreviewLinksWithSesame();
        }
      },
      adjustIframeSize: function() {
        if (!this.$refs.previewFrame) {
          return;
        }
        var self = this;
        let displayWidth = this.reportStyleDetails ? this.reportStyleDetails.preferred_viewport_width : 1440; // 1440; // We display the report as if it's on a 1280px wide screen
        let parentWidth = this.$refs.previewFrame.parentElement.parentElement.parentElement.offsetWidth;
        let containerWidth = Math.min(parentWidth, displayWidth) - 64; // Actual width of container, minus hardcoded padding for .box elements

        // Height set to refect actual height of report content
        let newHeight = this.$refs.previewFrame.contentWindow.document.body.scrollHeight;
        let zoomRatio = containerWidth / displayWidth;

        this.$refs.previewFrame.style.transform = `scale(${zoomRatio})`;
        this.$refs.previewFrame.style.height = newHeight + 'px';
        this.$refs.previewFrame.style.width = `${displayWidth}px`;

        // Shift the iframe left and up by half the difference between the "display" width and the zoomed-out width
        this.$refs.previewFrame.style.left = `-${(displayWidth - containerWidth) / 2}px`;
        this.$refs.previewFrame.style.top = `-${(newHeight - (newHeight * zoomRatio)) / 2}px`;
        this.iframe.loading = false;
        this.$nextTick(() => {
          // 40px / 100px are magic numbers to handle margins/padding/headers around the iframe
          self.$refs.previewFrame.parentElement.style.width = `${containerWidth + 40}px`;
          self.$refs.previewFrame.parentElement.style.height = `${(newHeight * zoomRatio) + 100}px`;
          self.iframe.loading = false;
        })
      },
      wrapPreviewLinksWithSesame: function () {
        const newTabLinksInReport = this.$refs.previewFrame.contentDocument.querySelectorAll('a[href][target=_blank]');
        newTabLinksInReport.forEach(newTabLink => {
          let url = new URL(newTabLink.href);
          url.searchParams.set('is_embed', '1');
          newTabLink.href = wrapUrlWithSesameLogin(url.href);
        });
      },
      applyValuesToScreens: function() {
        // This takes the applied values (portfolio default or overriden), and ensures that
        // the checkboxes passed to the ScreenSelectList component are active/inactive based
        // on the metrics that make up the persona.
        if (!this.activePortfolio.id) {
          return [];
        }
        let valueScreensById = [];
        let screenSets = this.activeValues;
        for (let i in screenSets) {
          valueScreensById.push(...screenSets[i].metrics.map((i) => {
            return i.metric_description;
          }))
        }
        if (valueScreensById.length === 0) {
          for (let i in this.screensByIssue) {
            this.screensByIssue[i].slice(0, 4).forEach((itm) => {
              if (!itm.low_coverage) {
                itm.active = true;
              }
            });
          }
        }
        else {
          this.activePortfolio.applicable_screens.forEach((itm, idx, arr) => {
            itm.active = valueScreensById.indexOf(itm.id) > -1;
          });
        }
      },
      metaphorsChanged: function(newMetaphors, isEnabled) {
        this.appliedMetaphors = [];
        this.$nextTick(() => {
          this.appliedMetaphors.push(...newMetaphors);
          this.institutionalSections.metaphor = isEnabled;
        });
      },
      refreshIframeSrcDoc: async function() {
        const response = await apiFetch(this.iframeSrc + '&tour=true', {headers: {'Content-Type': 'text/html'}});
        this.iframe.srcdoc = await response.text();
        this.iframe.loading = false;
      },
      syncQueryString: function() {
        let params = {
          reportType: this.reportType,
          reportStyle: this.reportStyle,
          bgcolor: this.bgcolor,
          dollarsOrPercentages: this.dollarsOrPercentages,
        }
        if (this.activePortfolio.id) {
          params.reporting = this.activePortfolio.external_id;
        }
        if (this.benchmarkPortfolio.id) {
          params.benchmark = this.benchmarkPortfolio.external_id;
        }
        if (this.valuesPortfolio.id) {
          params.values_from = this.valuesPortfolio.external_id;
        }
        if (this.activeValues.length > 0) {
          params.values = this.activeValues.map((itm) => itm.id).join(',');
        }
        let newParams = new URLSearchParams(params);
        let href = window.location.href;
        if (window.location.search) {
          href = window.location.href.replace(window.location.hash, '').replace(window.location.search, '');
        }
        window.history.replaceState({}, '', `${href}?${newParams}${window.location.hash}`);
      },


      previewSrc: function(isIframe) {
        /*
        this.reportURLBase was originally this.$refs.typePicker.selectType
        That stopped working with some changes related to supporting embeds, but unclear why.
        We are now listening to the @input event on ReportTypePicker and updating reportURLBase which seems to work.
        WARNING: We suspect using $refs may sometimes cause strange behavior with reactivity/state, so developer beware.
        */

        if (!this.reportURLBase
            || !this.activePortfolio
            || !this.activePortfolio.applicable_screens
            || this.activePortfolio.applicable_screens.length === 0
        ) {
          return;
        }

        let reportType = this.reportType;
        let reportStyle = this.reportStyle;
        let paramItems = {
          report_type: reportStyle,
          bgcolor: this.bgcolor,
          dollarsOrPercentages: this.dollarsOrPercentages,
        }
        if (!this.benchmarkNoEngagement) {
          paramItems.benchmark_no_engagement = this.benchmarkNoEngagement;
        }

        if (reportType && reportStyle) {
          let screens;
          if (reportType === 'metaphor' || reportType === 'institutional') {
            screens = this.appliedMetaphors.map((itm) => itm.metaphor_id).join(',');
            paramItems.m = screens;
          }
          if (reportType === 'impact' || reportType === 'institutional' || reportType === 'persona') {
            screens = this.activePortfolio.applicable_screens
              .filter((itm) => {
                return itm.active;
              })
              .map((itm) => {
                return itm.id
              })
              .join(',');

              paramItems.screens = screens;
          }
          if (this.reportType === 'institutional') {
            for (let k in this.institutionalSections) {
              paramItems[`${k}_section`] = Number(this.institutionalSections[k]);
            }
          }

          if (isIframe) {
            paramItems.is_iframe = 1;
          }

          let slug;

          if(this.activePortfolio.slug.startsWith('$')) {
            this.activePortfolio.slug = new Symbol(this.activePortfolio.slug).encode();
          }
          if(this.benchmarkPortfolio && this.benchmarkPortfolio.slug && this.benchmarkPortfolio.slug.startsWith('$')) {
            this.benchmarkPortfolio.slug = new Symbol(this.benchmarkPortfolio.slug).encode();
          }

          if (this.benchmarkPortfolio && this.benchmarkPortfolio.slug) {
            slug = `${this.activePortfolio.slug}:${this.benchmarkPortfolio.slug}`;
          }
          else {
            slug = this.activePortfolio.slug;
          }

          if (this.valuesPortfolio?.id) {
            paramItems.values_from = this.valuesPortfolio.external_id || this.valuesPortfolio.id;
          }

          if (this.reportType === 'persona') {
            paramItems.values = this.activeValues.map((i) => { return i.id }).join(',')
            paramItems.portfolio = slug;

            let params = new URLSearchParams(paramItems);
            return `${this.reportURLBase}?${params}`;
          }
          else {
            let params = new URLSearchParams(paramItems);
            return `${this.reportURLBase}${slug}/?${params}`;
          }

        }
      },
      selectBenchmark: function(option) {
        this.benchmarkPortfolio = option ? option : {id: null, portfolio_type: null};
        if (this.activePortfolio.id) {
          this.selectPortfolio(this.activePortfolio, true);
        }
      },
      selectValuesSource: function(option) {
        this.valuesPortfolio = option ? option : {id: null, portfolio_type: null};
        this.valuesChangeCallback(option.screen_sets);
        this.applyValuesToScreens();
      },
      sendToOrion: function() {
        apiFetch(`/convert_report/?${this.previewSrc().split('?')[1]}&slug=${this.activePortfolio.slug}&send_to_orion=1`)
          .then((data) => {
            console.log('Began sending process.')
          })

        console.log('Would send to Orion');
      },
      selectPortfolio: function(option, newBenchmark = false) {
        var self = this;
        if (option && option.id) {
          apiFetch(`/api/v1/portfolios/${option.external_id}/`)
            .then((data) => {
              return data.json();
            })
            .then((data) => {
              if (data?.portfolio?.default_benchmark && !newBenchmark) {
                this.benchmarkPortfolio = data.portfolio.default_benchmark;
              }
              option.details = data.portfolio;
              option.name = data.portfolio.name;
              apiFetch(`/api/v1/portfolios/${option.external_id}${this.benchmarkPortfolio.external_id ? ':' + this.benchmarkPortfolio.external_id : ''}/report/impact/?include_low_coverage=1`)
                .then((reportData) => {
                  return reportData.json();
                })
                .then((reportData) => {
                  option.applicable_screens = [];
                  option.applicable_screens.push(
                    ...reportData.report.metrics
                    .filter((itm) => {
                      return this.metrics.byId[itm.impact_factor_id];
                    })
                    .map((itm) => {
                      const metric = this.metrics.byId[itm.impact_factor_id];
                      metric.active = false;
                      return metric;
                    })
                  );

                  this.activePortfolio = option;
                  if (!self.valuesPortfolio.id && data.portfolio.screen_sets.length > 0) {
                    this.valuesChangeCallback(data.portfolio.screen_sets);
                  }
                  else {
                    this.applyValuesToScreens();
                  }
                });
            });
        }
        else {
          this.activePortfolio = {id: null, portfolio_type: null};
        }
      },
      reportTypeChanged: function(reportURLBase, reportType, reportStyle, reportDetails) {
        this.reportType = reportType;
        this.reportStyle = reportStyle;
        this.reportStyleDetails = reportDetails;
        this.handleReportTypeChange(reportURLBase);
        this.bgcolor = reportDetails.bgcolor;
        console.log(`Report details updated [${reportType}, ${reportStyle}]:`);
        console.log(reportDetails);
      },
      bgColorChanged: function(color) {
        this.bgcolor = color;
      },
      dollarsOrPercentagesChanged: function(choice) {
        this.dollarsOrPercentages = choice;
      },
      valuesChangeCallback: function(newValues) {
        this.activeValues = [];
        newValues.forEach((itm) => {
          // TODO: This should be done somewhere else in a API provider
          itm.metrics.forEach((m) => {
            m.details = this.metrics.byId[m.metric_description];
          })
        });
        this.activeValues.push(...newValues);
        this.applyValuesToScreens();
      },
      getTickerPlaceholder: function() {
          return this.tickerSearch ? "Choose a ticker to report on" : "Choose a portfolio to report on";
      },
      getBenchmarkTickerPlaceholder: function() {
          return this.tickerBaselineSearch ? "Choose a ticker to report on as benchmark" : "Blended Benchmark Portfolio is default";
      },
      handleReportTypeChange(data) {
        this.reportURLBase = data?.[0].url_base || '';
      },
      sendMetaphorsToReport() {
        // Sends the selected metaphors to report iframe
        const metaphors = this.appliedMetaphors.map((m) => m.metaphor_id);
        this.sendMessage({ event: 'metaphors-changed', metaphors });
      },
      sendMessage(data) {
        // Sends a message to the report iframe
        const iframe = this.$refs.previewFrame.contentWindow;
        iframe.postMessage(data, '*');
      },
      handleMessage(event) {
        // Handles messages from the report iframe
        const data = event.data;
        if(data.mounted === 'Metaphors.vue') {
          // Metaphors.vue component was just mounted, send metaphors again.
          // In case the report loaded after the metaphors were selected
          this.sendMetaphorsToReport();
        }
      }
    },
    created: async function() {
      this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;

      var self = this;
      this.$root.advisor = new Advisor(this.advisor);

      if(this.$root.advisor.firm.reports_holdings_default_show_percentages == true) {
        this.dollarsOrPercentages = 'percentages';
      }

      let metricResponse = await apiFetch('/api/v1/impact_factors/');
      let metricData = await metricResponse.json();
      metricData.metrics.forEach((itm) => {
        itm.active = false;
        this.metrics.a.push(itm);
        this.metrics.byId[itm.id] = itm;
      });

      let reportingPortfolio, benchmarkPortfolio, valuesPortfolio, values;
      if (window.location.search) {
        let urlParams = new URLSearchParams(window.location.search);
        reportingPortfolio = urlParams.get('reporting');
        benchmarkPortfolio = urlParams.get('benchmark');
        valuesPortfolio = urlParams.get('values_from');
        values = urlParams.get('values');
      }

      let valuesSource;
      if (valuesPortfolio && valuesPortfolio.indexOf('prospect_') === 0) {
        valuesSource = apiFetch(`/api/v1/prospects/${valuesPortfolio}/`);
      }
      else if (valuesPortfolio) {
        valuesSource = apiFetch(`/api/v1/portfolios/${valuesPortfolio}/`);
      }

      const [portfolioResp, benchmarkResp, valuesResp] = await Promise.all([
        reportingPortfolio ? apiFetch(`/api/v1/portfolios/${reportingPortfolio}/`) : Promise.resolve(),
        benchmarkPortfolio ? apiFetch(`/api/v1/portfolios/${benchmarkPortfolio}/`) : Promise.resolve(),
        valuesSource,
      ])

      if (portfolioResp) {
        const portfolioData = await portfolioResp.json();
        this.selectPortfolio(portfolioData.portfolio);
      }

      if (benchmarkResp) {
        const benchmarkData = await benchmarkResp.json();
        this.selectBenchmark(benchmarkData.portfolio);
      }

      if (valuesResp) {
        const valuesData = await valuesResp.json();
        this.selectValuesSource(valuesPortfolio.indexOf('prospect_') === 0 ? valuesData.prospect : valuesData.portfolio);
      }

      if (values) {
        let valuesResponse = await apiFetch(`/api/v1/screen_sets/?ids=${values}`);
        let valuesData = await valuesResponse.json();
        this.$nextTick(() => {
          self.valuesChangeCallback(valuesData.screen_sets);
        });
      }

      this.ready = true;

      let resizeDebounce = null;

      window.addEventListener('report-rendered', (evt) => {
        // We fire the report-rendered event on the window.parent of the
        // report page itself whenever the report has a major repaint. This
        // allows us to just re-fit the iframe around it every time it fires
        // rather than trying to figure out exactly when it's "finished".
        // Then we wait 500ms for good measure.
        window.setTimeout(this.onPreviewFrameLoad, 1500);
      });

      window.addEventListener('resize', (evt) => {
        window.clearTimeout(resizeDebounce);
        this.$refs.previewFrame.style.visibility = 'hidden';
        this.$refs.previewFrame.style.position = 'absolute';

        resizeDebounce = window.setTimeout(() => {
          this.adjustIframeSize();
          this.$refs.previewFrame.style.visibility = 'visible';
          this.$refs.previewFrame.style.position = 'relative';
          resizeDebounce = null;
        }, 750);
      });
    },
    mounted() {
      window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
      window.removeEventListener('message', this.handleMessage);
    },
  }
</script>

<style lang="scss">
.flexvaluesmenu {
  display: flex;
  justify-content: space-between;
}
.preview {
  position: relative;
  transition: filter 500ms, opacity 500ms, saturation 500ms;
}
.preview.loading {
  filter: blur(10px) opacity(0.5) saturate(0.5);
}
.spinning {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.comparison-portfolio-is-benchmark {
  margin-top: 0.33rem;
}
</style>

<style scoped>
.component {
  display: flex;
  gap: 0;
}

.main {
  flex-grow: 1;
}

.side {
  flex-shrink: 0;
  width: 20rem;
  margin-left: 1.5rem;
}
</style>